import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { generalActions } from "../store/actions";
import store from "../store";
import { handleLogout } from "../store/services/service";

export const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    accept: "application/json",
    "content-type": "application/json",
  },
});

function isTokenAboutToExpire(expiryTime) {
  const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds since epoch
  const timeRemaining = expiryTime - currentTime;
  return timeRemaining <= 1800 && timeRemaining > 0;
}

function isTokenExpired(expiryTime) {
  const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds since epoch
  const timeRemaining = expiryTime - currentTime;
  return timeRemaining < 0;
}

apiInstance.interceptors.response.use(
  async (response) => {
    try {
      const accessToken = localStorage?.getItem("accessToken");
      const refreshToken = localStorage?.getItem("refreshToken");
      const decodedToken = accessToken && jwtDecode(JSON.parse(accessToken));

      if (isTokenAboutToExpire(decodedToken?.exp)) {
        const payload = JSON.stringify({
          accessToken: accessToken?.replace(/"/g, ""),
          refreshToken: refreshToken?.replace(/"/g, ""),
        });
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken?.replace(/"/g, "")}`,
        };

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}token/refresh`,
          {
            method: "POST",
            headers: headers,
            body: payload,
          }
        );

        if (response?.status === 200) {
          const data = await response?.json();
          localStorage.setItem(
            "accessToken",
            JSON.stringify(data?.accessToken)
          );
          localStorage.setItem(
            "refreshToken",
            JSON.stringify(data?.refreshToken)
          );
        }
      }
    } catch (error) {
      handleLogout();
    }

    return response;
  },

  (error) => {
    const accessToken = localStorage?.getItem("accessToken");
    const decodedToken = jwtDecode(accessToken);

    if (isTokenExpired(decodedToken?.exp)) {
      store.dispatch(
        generalActions.showToast({
          title: "Your session has expired. Please login again.",
          type: "error",
        })
      );
      window.location.href = "/";
      if (
        error?.response &&
        (error?.response?.status === 401 || error?.response?.status === 403)
      ) {
        const user = localStorage.getItem("user");
        if (user) {
          localStorage.clear();
        }
      }
      handleLogout();
    }

    return Promise.reject(error);
  }
);

export const routes = {
  getResourceMonitering: "/Resources/Monitor",
  getShiftsList: "/Shifts",
  getTasks: "/Resources/:resourceId/Monitor",
  getContribution: "/Resources/:resourceId/Contribution",
  timeOff: "/Leaves",
  timeline: "/Projects/:id/TimeLine",
  bascelineability: "/Projects/:id/Baselines",
  createBaseline: "/Projects/:id/Baselines",
  markTaskCompleted: "Tasks/:id/Status",
  taskDependencies: "Tasks/:id/Dependencies",
  taskDates: "Tasks/:id/Dates",
  getTaskById: "/Tasks/:id",
  getProgramTimeline: "/Programs/:id/TimeLine",
  getProjectTimeline: "/Projects/:id/SummaryTimeLine",
  getPortfolioTimeline: "/Portfolios/:id/timeline",
};
